<template>
    <v-flex xs12 v-if="items.length>0">
        <v-card class="">
            <v-card-title>
                <div class="subheading">
                    {{title}}
                </div>
                <v-btn v-if="step" fab right absolute dark small color="primary" @click="setStep(step)" :disabled="disabled">
                    <v-icon>edit</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-data-table
                        :items="items"
                        class="elevation-0"
                        hide-actions
                        hide-headers
                        style="max-width:768px; margin: 0 auto"
                >
                    <template v-slot:items="props">
                        <template v-if="props.item.value">
                            <td width="50%">{{ props.item.name}}</td>
                            <td width="50%" v-if="props.item.type === 'list'">
                                <div v-for="listItem in props.item.value">
                                    {{listItem}}
                                </div>
                            </td>
                            <td class="py-1" width="50%" v-else>{{ props.item.value }}</td>
                        </template>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </v-flex>
</template>

<script>
    import {mapMutations} from 'vuex'

    export default {
        name: "SummaryTable",
        props: {
            items: Array,
            title: String,
            step: Number,
            disabled: Boolean
        },
        methods: {
            ...mapMutations('stepper', [
                'setStep'
            ]),
        }
    }
</script>

<style scoped>

</style>